export default __webpack_public_path__ + "static/media/home.a6d5186c.png";